import React, { useState } from 'react'
import moment from 'moment'
import { DatePicker } from 'antd'

import { usePet } from '../../modules'

import Modal from "../reusable/modal"
import Datepicker from '../reusable/datePicker'

const AdjustDates = ({ toggle, visible, admission, onPerform }) => {
    const [from, setFrom] = useState(admission?.servedOn ?? null)
    const [to, setTo] = useState(admission?.seenOn ?? null)

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Date has been edited', ops('success'))
        
        setTimeout(toggle, 300)
    }

    let ops = from && to ? { from, to } : from ? { from } : to ? { to }: {}

    const [{ loading }, execute] = usePet('editAdmissionDates', {
        id: admission?._id,
        ...ops
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adjusting dates...' } })

    return (
        <Modal
            w={ 400 }
            title="Adjust Dates"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Admission Date
                    </label>
                    <Datepicker format="MM/DD/YYYY" value={ from } onChange={ setFrom } />
                </div>
                {
                    admission?.seen &&
                    <div className="w-full px-3 mb-1">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Discharge Date
                        </label>
                        <Datepicker format="MM/DD/YYYY" value={ to } onChange={ setTo } />
                    </div>
                }
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default AdjustDates